import API_CONFIG from '../config/api.config';
import apiClient from './apiClient';

const delay = (ms = API_CONFIG.MOCK_DELAY) => new Promise(r => setTimeout(r, ms));

const MOCK_SESSIONS = [
  { id: 's1', device: 'Chrome on MacBook Pro',   location: 'Mumbai, India',    ip: '103.21.xx.xx', time: 'Today, 9:42 AM',     current: true  },
  { id: 's2', device: 'Safari on iPhone 15',      location: 'Mumbai, India',    ip: '49.36.xx.xx',  time: 'Yesterday, 8:15 PM', current: false },
  { id: 's3', device: 'Chrome on Windows 11',     location: 'Bengaluru, India', ip: '122.xx.xx.xx', time: 'Mar 3, 2:30 PM',     current: false },
  { id: 's4', device: 'Firefox on Ubuntu',        location: 'Unknown',          ip: '51.xx.xx.xx',  time: 'Feb 28, 11:00 PM',   current: false },
  { id: 's5', device: 'DevBrains Android App',    location: 'Delhi, India',     ip: '106.xx.xx.xx', time: 'Feb 25, 6:45 AM',    current: false },
];

const MOCK_ACTIVITY = [
  { id: 'a1', device: 'Chrome on MacBook Pro',  location: 'Mumbai, India',    ip: '103.21.xx.xx', time: 'Today, 9:42 AM',     status: 'success', current: true  },
  { id: 'a2', device: 'Safari on iPhone 15',    location: 'Mumbai, India',    ip: '49.36.xx.xx',  time: 'Yesterday, 8:15 PM', status: 'success', current: false },
  { id: 'a3', device: 'Chrome on Windows 11',   location: 'Bengaluru, India', ip: '122.xx.xx.xx', time: 'Mar 3, 2:30 PM',     status: 'success', current: false },
  { id: 'a4', device: 'Firefox on Ubuntu',      location: 'Unknown',          ip: '51.xx.xx.xx',  time: 'Feb 28, 11:00 PM',   status: 'failed',  current: false },
  { id: 'a5', device: 'DevBrains Android App',  location: 'Delhi, India',     ip: '106.xx.xx.xx', time: 'Feb 25, 6:45 AM',    status: 'success', current: false },
];

function makeMockBackupCodes() {
  const hex = () => Math.floor(Math.random() * 65536).toString(16).toUpperCase().padStart(4, '0');
  return Array.from({ length: 10 }, () => `${hex()}-${hex()}`);
}

const securityService = {

  // GET /users/me/sessions
  async getSessions() {
    if (API_CONFIG.MOCK) {
      await delay();
      return { sessions: MOCK_SESSIONS };
    }
    return apiClient.get('/users/me/sessions');
  },

  // DELETE /users/me/sessions/:id
  async revokeSession(sessionId) {
    if (API_CONFIG.MOCK) {
      await delay(600);
      return { success: true };
    }
    return apiClient.delete(`/users/me/sessions/${sessionId}`);
  },

  // DELETE /users/me/sessions/all
  async revokeAllSessions() {
    if (API_CONFIG.MOCK) {
      await delay(600);
      return { success: true };
    }
    return apiClient.delete('/users/me/sessions/all');
  },

  // GET /users/me/login-activity
  async getLoginActivity() {
    if (API_CONFIG.MOCK) {
      await delay();
      return { activity: MOCK_ACTIVITY };
    }
    return apiClient.get('/users/me/login-activity');
  },

  // PUT /users/me/password
  async changePassword(currentPassword, newPassword) {
    if (API_CONFIG.MOCK) {
      await delay(800);
      return { success: true };
    }
    return apiClient.put('/users/me/password', { currentPassword, newPassword });
  },

  // GET /users/me/notifications/security
  async getSecurityNotifications() {
    if (API_CONFIG.MOCK) {
      await delay();
      return { notifications: { newLogin: true, newDevice: true, passwordChange: true, payoutRequest: true } };
    }
    return apiClient.get('/users/me/notifications/security');
  },

  // PUT /users/me/notifications/security
  async updateSecurityNotifications(prefs) {
    if (API_CONFIG.MOCK) {
      await delay(300);
      return { success: true };
    }
    return apiClient.put('/users/me/notifications/security', prefs);
  },

  // POST /2fa/setup → { qrCode, manualKey }
  async setup2FA() {
    if (API_CONFIG.MOCK) {
      await delay(600);
      return { qrCode: null, manualKey: 'JBSWY3DPEHPK3PXP' };
    }
    return apiClient.post('/2fa/setup');
  },

  // POST /2fa/verify-setup → { backupCodes }
  async verify2FA(code) {
    if (API_CONFIG.MOCK) {
      await delay(900);
      return { success: true, backupCodes: makeMockBackupCodes() };
    }
    return apiClient.post('/2fa/verify-setup', { code });
  },

  // POST /2fa/disable
  async disable2FA(code) {
    if (API_CONFIG.MOCK) {
      await delay(700);
      return { success: true };
    }
    return apiClient.post('/2fa/disable', { code });
  },

  // POST /2fa/backup-codes → { backupCodes }
  async regenerateBackupCodes() {
    if (API_CONFIG.MOCK) {
      await delay(600);
      return { backupCodes: makeMockBackupCodes() };
    }
    return apiClient.post('/2fa/backup-codes');
  },

  // GET /users/me/export
  async exportData() {
    if (API_CONFIG.MOCK) {
      await delay(1200);
      return { downloadUrl: null, message: '[MOCK] Export ready — download link will be emailed to you.' };
    }
    return apiClient.get('/users/me/export');
  },

  // DELETE /users/me
  async deleteAccount(password) {
    if (API_CONFIG.MOCK) {
      await delay(800);
      return { success: true };
    }
    return apiClient.delete('/users/me', { data: { password } });
  },
};

export default securityService;
